import BasicNoMatchComponent from '@wandb/weave/common/components/BasicNoMatchComponent';
import Loader from '@wandb/weave/common/components/WandbLoader';
import React from 'react';

import {DD_PRIVACY_HIDDEN} from '../../../util/datadog/privacy';
import type {FileBrowserFile, UseFileBrowserLoadFileUrl} from '../types';
import {useBlobUrl} from './useBlobUrl';
import {useNetronUrl} from './useNetronUrl';

interface NetronProps {
  useLoadFileUrl: UseFileBrowserLoadFileUrl;
  file: FileBrowserFile;
}

export function NetronPreview({
  useLoadFileUrl,
  file: fileToQuery,
}: NetronProps) {
  // It's tempting to fetch directUrl in the filebrowser files query, but directUrls
  // expire after 60s, so we need to fetch it just in time, right as we render the
  // iframe.
  const query = useLoadFileUrl(fileToQuery);
  const file = query.loading ? null : query.file;
  // Signed directUrls can point at our own host or a sibling subdomain, which
  // the Netron URL guard must keep blocking; hand Netron a blob: URL instead.
  const blob = useBlobUrl(file?.directUrl);
  const netronUrl = useNetronUrl(
    file && blob.blobUrl ? {...file, directUrl: blob.blobUrl} : null,
    (window as any).thirdPartyAnalyticsOK
  );

  if (query.loading || blob.loading) {
    return <Loader name="file-browser" />;
  }

  if (blob.error || !netronUrl) {
    return <BasicNoMatchComponent />;
  }

  return (
    <iframe
      className="w-full h-full border-0 flex-grow"
      data-dd-privacy={DD_PRIVACY_HIDDEN}
      title="Netron preview"
      src={netronUrl}
    />
  );
}
